import React from 'react'
import { domToReact } from 'html-react-parser'
import get from 'tcweb-material-components/core/poly/get'
import { makeStyles } from '@material-ui/styles'
import classnames from 'classnames'

import { cssToObj } from '../../utilities/helpers'

const useClasses = makeStyles(() => ({
    root: {
        minHeight: ({ minHeight }) => !!minHeight ? `${minHeight} !important` : '100% !important', // Overwrite WP styles pixel default
        backgroundImage: ({ backgroundImage }) => !!backgroundImage && `${backgroundImage} !important`  // Overwrite WP styles pixel default
    }
}))

const CoverSwap = ({ children, options, className='', attribs }) => {
    const styles = get(attribs, 'style', '').split(';')
    const classes = useClasses({...cssToObj(styles)})

    return (
        <div className={classnames(className, attribs.class, classes.root)}>
            {domToReact(children, options)}
        </div>
    )
}

export default CoverSwap

